module.exports = __webpack_public_path__ + "static/media/edinburgh-32.de941a90.jpg";